import { FormattedMessage } from 'react-intl';
import * as React from 'react';

export const opts: number[] = [0, 1, 2, 3, 4, 5, 6];

export const optFormatter = (n: string | number): React.JSX.Element => (
  <FormattedMessage id={`functionalPerformance.opts.modifiedRankinScale.rating.${n}`} />
);
